module.exports = __webpack_public_path__ + "static/room1-a9c2ff4b09679bf657c8d4eb918f9bfa.jpg";